import React from 'react'
import Overview from 'components/insightContent/visualization/Overview'
import { InsightContentSettingType } from 'components/insightContent/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import useCrosstabData from 'components/widget/CrosstabWidgets/share/Crosstab/useCrosstabData'
import ComparisonMode from 'enums/ComparisonMode'
import Title from './Title'
import { resolveAverage } from '../utils/averageResolver'
import { isVoc } from '../utils/viewOptionUtils'

const AllTopicsAverageMeasure = ({
  detailSetting,
  widgetId,
  isAudienceQuery
}: {
  detailSetting: InsightContentSettingType
  widgetId: number
  isAudienceQuery: boolean
}) => {
  const { crossTabs } = useCrosstabData(widgetId, isAudienceQuery)
  const { viewOption, rowComparisonMode } = detailSetting

  const average = resolveAverage(detailSetting, crossTabs)
  const formatter =
    isVoc(viewOption) && !Number.isInteger(average)
      ? new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        })
      : new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })

  return (
    <UnexpectedErrorBoundary>
      <Overview
        title={
          <Title
            viewOption={viewOption}
            isForAllTopics={rowComparisonMode === ComparisonMode.TOPICS}
          />
        }
        count={formatter.format(average)}
        status="succeeded"
      />
    </UnexpectedErrorBoundary>
  )
}

export default AllTopicsAverageMeasure
